import { memo } from 'react'
import cn from 'classnames'

import { MASCOT_POSE_IMAGE } from './config'
import type { LunyaMascotProps } from './types'

import styles from './LunyaMascot.module.scss'

/**
 * Маскот Луни в одной из поз (onb.a1–a3, шаги совместимости, натальной карты и т.п.).
 * Артов по позам пока нет — все позы указывают на общий кадр, см. config.ts.
 */
export const LunyaMascot = memo(function LunyaMascot(props: LunyaMascotProps) {
  const { pose = 'BASE', size, height = size, hasGlow = false } = props

  return (
    <img
      className={cn(styles.root, hasGlow && styles.hasGlow)}
      src={MASCOT_POSE_IMAGE[pose]}
      alt=''
      width={size}
      height={height}
      style={{ width: size, height }}
    />
  )
})
